import {Aside} from '../../aside/aside'
import {Header} from '../../header/header'
import {HeaderSize} from '../../header/types'
import * as Styled from './row-based-layout.styled'
import {useDimensions} from '../../../../../contexts/dimensions/use-dimensions'
import useTypedSelector from '../../../../../hooks/use-typed-selector'
import {errorSelector} from '../../../../../store/state/session-data/selectors'
import {type ReactNode, type JSX} from 'react'
import {LoginPageTemplate} from '../../../page-template/login-page-template'
import {customLogoSelector} from '../../../../../store/state/config/selectors'
import {HeaderCustomLogo} from '../../header/header-custom-logo'

interface RowBasedLoginLayoutProps {
    children: ReactNode
}
export function RowBasedLoginLayout({children}: RowBasedLoginLayoutProps): JSX.Element {
    const {height} = useDimensions()
    const error = useTypedSelector(errorSelector)
    const hasError = error ? error.length > 0 : false
    const customLogoFlag = useTypedSelector(customLogoSelector)

    return (
        <LoginPageTemplate>
            <Styled.Content>
                {customLogoFlag ? (
                    <HeaderCustomLogo headerSize={HeaderSize.SMALL} />
                ) : (
                    <Header headerSize={HeaderSize.SMALL} />
                )}
                <Styled.CallToActionSection showError={hasError}>
                    {children}
                </Styled.CallToActionSection>
                <Styled.AsideWrapper height={height}>
                    <Aside layout="ROW" />
                </Styled.AsideWrapper>
            </Styled.Content>
        </LoginPageTemplate>
    )
}
